module.exports = __webpack_public_path__ + "static/media/VN.3e303f7f.svg";